<div class="configuration-accelerators-program-facilitators-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="facilitators()"></grid-content>
</div>